module.exports = __webpack_public_path__ + "img/jenkins.0e04e41a.png";